/**
 * @fileOverview The main entry point to your standalone. Start editing here.
 */

import React from 'react'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/reset.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/site.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/segment.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/container.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/header.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/image.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/list.css'
import './styles.scss'
import { Masthead } from '@ta-interaktiv/react-masthead'
import { Footer } from '@ta-interaktiv/react-footer'
import { ThemeSwitch } from '@ta-interaktiv/react-theme-switch'

import Calendar from '../calendar'

// TODO Set the correct article ID here
const ARTICLE_ID = '736427463426'

export function AppComponent() {
  return (
    <div className='index'>
      <Masthead articleId={ARTICLE_ID} />
      <ThemeSwitch />

      <div className='ui vertical fitted segment headerwrapper'>
        <div className='ui container'>
          <div className='ui header'>
            <h1>Der Tagi klopft an</h1>
            <h2>
            Kein Glühweintrinken am Feierabend, kein Fondue-Abend mit Freunden. Zum Trost haben wir im Advent täglich über eine Begegnung berichtet, die uns guttat.
            </h2>
          </div>
        </div>
      </div>

      <div className='ui vertical segment'>
        <div className='ui text container'>
          <div className='ta metainfo'>
            <div className='ta author'>
              <span>Claudia Meisterhans</span>, <span>Hélène Arnet</span>,{' '}
              <span>Simon Huwiler</span>
            </div>
          </div>
          <p>
          In diesem speziellen Jahr sind menschliche Begegnungen ein Risikofaktor geworden. Wie wichtig auch kurze Gespräche und Plaudereien für das Wohlbefinden sind, realisieren viele von uns erst jetzt, wo sie uns fehlen. Der «Tagi» hat deshalb im Advent jeden Tag an eine Tür geklopft und etwas über die Person erzählt, die geöffnet hat. Wir haben gefragt, was wir schon lange fragen wollten, wir haben Menschen getroffen, die wir – vielleicht nur im Stillen – schon lange bewundern. Und wir hoffen, dass diese kurzen Begegnungen nicht nur uns, sondern auch unseren Leserinnen und Lesern ein bisschen Freude bereiten.
          </p>
        </div>
      </div>

      <div className='calenderwrapper'>
        <Calendar />
        <div style={{ clear: 'both' }} />
      </div>

      <Footer
        articleId={ARTICLE_ID}
        credits={[
          ['Projektleitung', 'Hélène Arnet'],
          ['Illustrationen', 'Claudia Meisterhans'],
          ['Entwicklung', 'Simon Huwiler']
        ]}
        hidePortfolioTeaser
        hideUserFeedback
      />
    </div>
  )
}
